<template>
  <vue-multiselect
      :class="stateClass"
      :loading="pending"
      :options="options"
      :placeholder="$t('Please select')"
      :value="value"
      :taggable="taggable"
      multiple
      v-bind="$attrs"
      @input="$emit('input', $event)"
      @tag="handleNewTag"
      @search-change="handleSearch"
      @open="handleSearch(null)"
  />
</template>

<script>
import {formStateMixin} from 'bootstrap-vue/src/mixins/form-state';
import VueMultiselect from 'vue-multiselect/src/Multiselect';

export default {
  name: 'TagsSelect',
  components: {VueMultiselect},
  mixins: [formStateMixin],
  props: {
    value: {
      type: [Array],
      default: null,
    },
    taggable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      items: [],
      pending: false,
    };
  },
  computed: {
    options() {
      return this.items.map(({name}) => name);
    }
  },
  methods: {
    handleSearch(search = null) {
      if(this.internalSearch && this.options.length) {
        return;
      }

      if (this.timeout) {
        clearTimeout(this.timeout)
        this.timeout = null;
      }

      this.timeout = setTimeout(() => this.search(search), 300);
    },

    search(search = null) {

      this.pending = true;

      this.axios
          .get('/api/tags', { params: { search } })
          .then(({data}) => this.items = data.data || data)
          .catch(e => e.response || throw e)
          .finally(() => this.pending = false)
    },

    handleNewTag(tag) {
      this.items.push({name: tag});
      this.$emit('input', [tag].concat(this.value));
    }
  },
};
</script>
